import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Grid from "@material-ui/core/es/Grid";
import withStyles from "@material-ui/core/es/styles/withStyles";
import { changePageHeader } from "../AppActions";
import PageBase from "../../../components/PageBase";
import * as utils from "../../../utils";
import {FaCog} from "react-icons/fa";
import { HashLink } from "react-router-hash-link";
import * as classnames from "classnames";
import Typography from "@material-ui/core/es/Typography";
import Paper from "@material-ui/core/es/Paper";
import Link from "react-router-dom/es/Link";

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  section: {
    marginTop: "10px",
    maxWidth: "600px"
  },
  section2: {
    marginTop: "10px",
    maxWidth: "600px",
    padding: "0 14px !important"
  },
  welcomeContainer: {
    textAlign: "center"
  },
  welcomeText: {
    fontSize: "16px",
    margin: "16px 0",
    color: "#000000a6",
    whiteSpace: "pre-line"
  },
  root: {
    paddingTop: "30px",
    paddingBottom: "30px",
    paddingRight: '20px'
  },
  accountBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "rgba(0,0,0,0.65)",
    paddingLeft: "20px"
  },
  icon: {
    fill: "#3f51b5",
    fontSize: "34px"
  },
  headline: {
    paddingLeft: "20px",
    color: '#000'
  }
});

class Welcome extends Component {
  componentWillMount = () => {
    this.props.changePageHeader("My Account");
  };

  render() {
    const { user, brand, classes, app } = this.props;
    return (
      <div>
        <Grid container justify="center">
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            className={classnames(classes.section, classes.welcomeContainer)}
          >
            <img src={utils.getAppProps(brand).logoBig} />
            <br />
            <Typography component="p" className={classes.welcomeText}>
              {`Welcome ${user.name || user.email}
                            to ${brand.name}’s My Account center`}
            </Typography>
            <br />
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid xs={12} md={6} lg={4} item className={classes.section2}>
            <Link to="/account" style={{ textDecoration: "none" }}>
              <Paper className={classes.root} elevation={1}>
                <div className={classes.accountBox}>
                  <FaCog className={classes.icon} />
                  <Typography
                    variant="headline"
                    color="inherit"
                    className={classes.headline}
                  >
                    Account Management
                  </Typography>
                </div>
              </Paper>
            </Link>
            {/* <PageBase title="Account Management" icon={<FaCog/>} link="account">
                            <HashLink smooth to="account#delete-account"
                                      scroll={el => app.mainElement.scroll({
                                          top: el.offsetTop - 70,
                                          left: 0,
                                          behavior: 'smooth'
                                      })}>
                                Delete Your Account
                            </HashLink>
                        </PageBase> */}
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps({ app, user, brand }) {
  return { app, user, brand };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changePageHeader
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Welcome));



// WEBPACK FOOTER //
// ./src/containers/app/components/Welcome.js